class AddressController {
  constructor($scope) {
    "ngInject";

    if (this.firstLineReq) {
      this.configureForm();

      $scope.$on('parentFormConfigured', this.configureForm.bind(this));
    }
  }

  configureForm() {
    const ctrl = this;

    if (this.firstLineReq) {
      ctrl.formValidationService.addField({
        fieldName: 'line1',
        displayName: 'Address Line 1',
        model: ctrl.container,
        required: true,
        stringLength: {
          min: 5,
          max: 100
        }
      });
    }
  }
}

export default AddressController;



// WEBPACK FOOTER //
// ./client/app/components/common/address/address.controller.js